import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cb4fbc48"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb4fbc48')) {
      api.createRecord('cb4fbc48', component.options)
    } else {
      api.reload('cb4fbc48', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cb4fbc48", function () {
      api.rerender('cb4fbc48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin/views/layout/components/Sidebar/index.vue"
export default component.exports